export const malgorzataRzymyszkiewicz = {
    'meta': {
        'title': 'Psycholog, psychoterapeuta psychodynamiczny Małgorzata Rzymyszkiewicz • COLLIGO',
        'description': 'Jestem psychologiem oraz psychoterapeutą pracującym w nurcie psychodynamicznym. Zajmuję się psychoterapią indywidualną, grupową i diagnozą psychologiczną.'
    },
    'url': {
        'address': '/torun/zespol/psycholog-psychoterapeuta-malgorzata-rzymyszkiewicz/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/malgorzata-rzymyszkiewicz.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psycholog, psychoterapeuta Małgorzata Rzymyszkiewicz'
        }
    }
}